import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { Translate } from '@hydra/common/components';
import { Grid } from '@material-ui/core';
import get from 'lodash/get';

import List from '@hydra/routes/crawler/components/List';
import IssueTypeLabel from '@hydra/routes/crawler/components/IssueTypeLabel';
import VisualLinkIssue from '@hydra/routes/crawler/components/VisualLinkIssue';

import DCUrl from '@hydra/routes/crawler/utils/DCUrl';

const issueTypes = {
  'simple-redirect': {
    icon: 'simple-redirect'
  },
  'loop-redirect': {
    icon: 'redirect-loop'
  },
  'broken-redirect': {
    icon: 'broken-redirect'
  },
  'chain-redirect': {
    icon: 'redirect-chain'
  }
};

export class Http3xxRedirectsRow extends React.Component {
  static propTypes = {
    issue: PropTypes.object,
    columnStyles: PropTypes.array,
    relay: PropTypes.object
  }

  render () {
    const {
      columnStyles,
      issue,
      className: classNameProp
    } = this.props;

    const domain = get(this.props, ['relay', 'route', 'params', 'url'], '');
    const sourceUrl = new DCUrl(domain, issue.source_url);

    return (
      <Grid container className={classNameProp} alignItems='flex-start'>
        <Grid item {...columnStyles[0]}>
          <IssueTypeLabel severity={issue.severity} type={issue.type} amount={issue.redirect_urls.length} />
        </Grid>
        <Grid item {...columnStyles[1]}>
          {
            issue.code === -1
              ? <Translate content='crawler_misc' />
              : issue.code
          }
        </Grid>
        <Grid item {...columnStyles[2]}>
          <VisualLinkIssue
            extraClass='icon-type-arrow'
            icon={get(issueTypes, [issue.type, 'icon'], 'simple-redirect')}
            severity={issue.severity}
            urls={issue.redirect_urls.map(url => new DCUrl(domain, url))}
          />
        </Grid>
        <Grid item {...columnStyles[3]}>
          <List items={sourceUrl} />
        </Grid>
      </Grid>
    );
  }
}

export default createFragmentContainer(Http3xxRedirectsRow, {
  issue: graphql`
    fragment Http3xxRedirectsRow_issue on Http3xxRedirect {
      id
      type
      severity
      code
      redirect_count
      redirect_urls
      source_url
    }
  `
});
